import { render, staticRenderFns } from "./CopyStakeAutoclickerPromptsModal.vue?vue&type=template&id=81aa56fe&scoped=true&lang=pug"
import script from "./CopyStakeAutoclickerPromptsModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeAutoclickerPromptsModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeAutoclickerPromptsModal.vue?vue&type=style&index=0&id=81aa56fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81aa56fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextField,VTextarea})
